import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * /apply - where "Apply for a permit" lands.
 *
 * The nav used to say "Apply" and go to /find, while /apply was a redirect pointing
 * back at it - the label and the address disagreed, and the address people would
 * guess was the one that did nothing. This is the page the label promises.
 */
@Component({
    selector: 'app-apply-start',
    templateUrl: './apply-start.component.html',
    styleUrls: ['./apply-start.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ApplyStartComponent {}
